<template>


	<div class="relative f fy">


		<el-table class="f-1" :data="records" border stripe>

			<el-table-column prop="id" label="id">
			</el-table-column>
			<el-table-column prop="robotCode" label="robotCode">
			</el-table-column>
			<el-table-column prop="roleName" label="roleName">
			</el-table-column>
			<el-table-column prop="llm" label="llm">
			</el-table-column>
			<el-table-column prop="createTime" label="createTime">
			</el-table-column>
			<el-table-column label="operate">
				<template slot="header">
					<div class="relative cm-0-5">
						<el-button type="primary" size="mini" @click="load()">refresh</el-button>
						<el-button type="primary" size="mini" @click="create">create</el-button>
					</div>
				</template>
				<template slot-scope="scope">

					<el-button v-if="mode=='select'" type="primary" size="mini" @click="$emit('select',scope.row)">
						select
					</el-button>
					<div v-else class="relative cm-0-5">
						<el-button type="primary" size="mini" @click="update(scope.row)">
							update
						</el-button>
						<el-button type="danger" size="mini" @click="del(scope.row)">
							delete
						</el-button>
						<el-button type="primary" size="mini" @click="chat(scope.row)">
							chat
						</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination class="relative text-center mt-2" background layout="prev, pager, next, total" :total="total"
			:page-size="size" :current-page="page" @current-change="load">
		</el-pagination>
	</div>

</template>

<script>
	import OptionTag from '@/components/OptionTag'
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			OptionTag
		},
		data() {
			return {
				form: {

				},
				records: [],
				total: 0,
				pages: 0,
				size: 10,
				page: 1,
				params: {},

			}
		},
		mounted() {
			this.search();
		},
		methods: {
			search() {
				this.params = {
					...this.form,
					...this.propParams,
				}
				this.load(1);
			},
			load(page) {
				console.log(this.options)
				page = page || this.page || 1;
				request({
					loading: true,
					url: '/api/robot/selectRobotPage',
					data: {
						...this.params,
						page,
					},
					success: resp => {
						this.records = resp.data.records;
						this.total = resp.data.total;
						this.pages = resp.data.pages;
						this.page = page;
					}
				})

			},

			create() {
				dialogs.open('RobotForm', {
					title: 'create robot',
					success: this.load
				})
			},

			update(row) {
				dialogs.open('RobotForm', {
					title: 'editor robot',
					propForm: row,
					success: this.load
				})
			},
			del(row) {
				this.$confirm('Confirm to delete ?', 'Tip', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					request({
						url: '/api/robot/deleteRobot',
						data: {
							id: row.id
						},
						success: resp => {
							Message.success();
							this.load();
						}
					})
				}).catch(() => {});
			},

			chat(row) {
				window.open('#/chat_for_robot?robotId=' + row.id)
			},


		}
	}
</script>

<style>




</style>